var foo = {};

module.exports = foo;


/*****************
 ** WEBPACK FOOTER
 ** ./test.js
 ** module id = 2
 ** module chunks = 0
 **/